import { useCallback } from 'react';
import { Vibration } from 'react-native';

export function useVibration() {
  const vibrate = useCallback(() => {
    Vibration.vibrate(300);
  }, []);

  return { vibrate };
}
